import {GroupSeatType} from '@toolify/server/src/models/mongoose/GroupModel/enum/GroupSeatType'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {
  IGroupResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IGroupResponseInstance'

export const groupSeatGroupMetaByType: Record<GroupSeatType, {
  iconNameType: IconNameType
  translationKey: string
  infoTitleKey: string
  infoDescriptionKey: string
}> = {
  [GroupSeatType.Member]: {
    iconNameType: IconNameType.User,
    translationKey: 'settings.seatGroupMember',
    infoTitleKey: 'settings.seatGroupMemberInfoTitle',
    infoDescriptionKey: 'settings.seatGroupMemberInfoDescription',
  },
  [GroupSeatType.Field]: {
    iconNameType: IconNameType.UserHelmetSafety,
    translationKey: 'settings.seatGroupField',
    infoTitleKey: 'settings.seatGroupFieldInfoTitle',
    infoDescriptionKey: 'settings.seatGroupFieldInfoDescription',
  },
  [GroupSeatType.Guest]: {
    iconNameType: IconNameType.UserPlus,
    translationKey: 'settings.seatGroupGuest',
    infoTitleKey: 'settings.seatGroupGuestInfoTitle',
    infoDescriptionKey: 'settings.seatGroupGuestInfoDescription',
  },
  [GroupSeatType.Viewer]: {
    iconNameType: IconNameType.Eye,
    translationKey: 'settings.seatGroupViewer',
    infoTitleKey: 'settings.seatGroupViewerInfoTitle',
    infoDescriptionKey: 'settings.seatGroupViewerInfoDescription',
  },
}

export function getSeatGroupTitle(
  translate: (key: string) => string,
  group: Pick<IGroupResponseInstance, 'title' | 'isSeatGroup' | 'seatType'>,
  fallback = '',
): string {
  if(group.title) {
    return group.title
  }
  if(group.isSeatGroup && group.seatType) {
    return translate(groupSeatGroupMetaByType[group.seatType].translationKey)
  }
  return fallback
}

export function formatGroupSeatUsage(currentMemberCount: number, maxMemberCount: number | null): string {
  if(maxMemberCount === null || maxMemberCount === undefined) {
    return `${currentMemberCount}`
  }
  if(maxMemberCount < 0) {
    return `${currentMemberCount}/∞`
  }
  return `${currentMemberCount}/${maxMemberCount}`
}

export function getBuiltInGroupIds(
  groups: Array<Pick<IGroupResponseInstance, 'id' | 'isSeatGroup'>>,
): string[] {
  return groups.filter(group => group.isSeatGroup).map(group => group.id)
}

export function getUserBuiltInGroupId(
  userId: string,
  groupMemberIdsByGroupId: Record<string, string[]>,
  builtInGroupIds: string[],
): string | null {
  for(const groupId of builtInGroupIds) {
    if((groupMemberIdsByGroupId[groupId] || []).includes(userId)) {
      return groupId
    }
  }
  return null
}
